export default {
    state: {
        paronMember: localStorage.getItem('paronMember') === 0 ? 0 : JSON.parse(localStorage.getItem('paronMember')),
    },
    mutations: {
        setParonMember(state, paronMember) {
            state.paronMember = paronMember;
        }  
    },
    actions: {
        setParonMember({commit}, paronMember) {
            localStorage.setItem('paronMember', JSON.stringify(paronMember))
            commit('setParonMember', paronMember);
        }
    },
};